import type { MaskTemplateTypes } from '../types';

export function containsOnlyNumbers(str: string) {
  return /^\d+$/.test(str);
}

export const replaceChars = (word: string, template: MaskTemplateTypes) => {
  switch (template.toLowerCase()) {
    // - result: ** *** 2000
    case 'dob':
      // exclude year from masking
      if (word.length === 4 && containsOnlyNumbers(word)) {
        return word;
      }
      return word.replace(/[a-z\d]/gi, '*');
    // - result: A**** B***
    default:
      return word.replace(/\b(\w)(\w+)\b/g, function (_, first, rest) {
        return first + rest.replace(/\w/g, '*');
      });
  }
};

export const maskText = (text: string, template: MaskTemplateTypes) => {
  const words = text.split(' ');
  const securityWords = words.map((word) => {
    return replaceChars(word, template);
  });
  return securityWords.join(' ');
};
